import { createModuleContext } from '@rebuild/utils/moduleContext';
import { getCurrentInstance, computed } from 'vue';
import { useModuleData } from '@rebuild/hooks/data/useModuleData';
import { useModuleNavigation } from '@rebuild/hooks/useModuleNavigation';
import { getTimeStamp } from '@/utils/api';

const MODULE_NAME = 'summary';

function buildBaseCtx() {
	return {};
}

const { provide: provideCurrentContext, use: useCurrentContext } = createModuleContext(MODULE_NAME, buildBaseCtx);

const useCurrentReactive = () => {
	const { proxy } = getCurrentInstance();

	const timeRange = computed(() => [
		{ value: '', label: proxy.$t('enterprise.all') },
		{ value: 'lastOneYear', label: proxy.$t('enterprise.lastOneYear') },
		{ value: 'lastThreeYear', label: proxy.$t('enterprise.lastThreeYear') },
		{ value: 'lastFiveYear', label: proxy.$t('enterprise.lastFiveYear') }
	]);
	const timeRangeInMob = computed(() =>
		timeRange.value.map(item => ({
			...item,
			text: item.label,
			value: item.value
		}))
	);

	const { research } = useModuleData();
	const emptyResearch = computed(() => research.empty || !research.data?.rows?.length);
	const totalResearch = computed(() => research.data?.total || 0);
	const loadResearchData = (params = {}) => {
		return research.refresh({
			...params
		});
	};
	const getResearchData = computed(() => {
		return research.data?.rows || [];
	});

	const prepareParams = (options = {}) => {
		const { pagination, search, time } = options;
		const params = {};

		if (pagination) {
			params.pagestart = pagination.currentPage - 1;
			params.pagenum = pagination.pageSize;
		}
		if (search) {
			params.title = search;
		}
		if (time) {
			const [startTime, endTime] = getTimeStamp(time);
			params.startTime = startTime;
			params.endTime = endTime;
		}

		return params;
	};
	const afterMobLoaded = () => {
		const data = research.data;
		const newData = data?.rows || [];
		const total = data?.total || 0;

		return {
			data: newData,
			total
		};
	};

	const { viewModule } = useModuleNavigation();
	const previewResearch = item => {
		return viewModule('research', item);
	};

	return {
		timeRange,
		timeRangeInMob,

		research,
		emptyResearch,
		totalResearch,
		getResearchData,
		loadResearchData,
		prepareParams,
		afterMobLoaded,

		previewResearch
	};
};

export { provideCurrentContext, useCurrentContext, useCurrentReactive };
